<template>
  <v-main>
    <v-container fluid style="max-width: 400px;" class="pa-0">
      <v-row class="px-0">
        <v-col>
          <header1 class="my-5">Zähler</header1>
          <div v-if="(isFree)" class="text-xl-center mb-3 mt-10 ml-2">
            <div class="mt-3 pa-3"
                 style="border: 1px dashed dodgerblue; width: calc( 100% - 8px); height: 430px; border-radius: 5px; background-color: #0000cc10">
              <span class="headline">Aktivitäten mit praktischen Zählern tracken?</span>
              <Counter :demo="true" class="mt-4"/>
              <br/>
              Go <pro/> für insgesamt 10 Lebensbereiche bis zu 100 Aktivitäten, SMS-Erinnerung, Zähler und Stoppuhr!
              <br/><br/>
              <v-btn rounded class="d-flex mx-10 gelb dunkelblau--text" href="https://www.digistore24.com/product/410225"
                 target="_blank">Upgrade auf aimz PRO</v-btn>
            </div>
          </div>
          <div v-else class="mx-2 mt-10 px-2">
            <Counter v-for="activity in counters" :activity="activity" :targets="targets" :activity-sums="activitySums" :key="activity.id" class="mb-3"/>
            <div v-if="canConfig" class="d-flex mt-5">
              <v-btn-toggle class="mt-1 mx-auto">
                <v-btn @click="showDragDlg=true">
                  <v-icon>mdi-playlist-edit</v-icon>
                </v-btn>
                <v-btn @click="onConfigure">
                  <v-icon>mdi-cog</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>
          </div>
        </v-col>
      </v-row>
      <div class="d-flex">
        <v-btn class="mx-auto mt-3 mb-3" href="https://youtu.be/HGzd3k7bIl0" target="_blank">
          <v-icon class="mr-2">mdi-play-box-outline</v-icon> Videoanleitung
        </v-btn>
      </div>
    </v-container>
    <v-dialog v-model="showDlg" width="400" :fullscreen="isMobile">
      <v-card>
        <v-card-title>Zähler aufnehmen oder entfernen</v-card-title>
        <v-card-text>
          <v-checkbox v-for="item in countersToUse"
                      hide-details :label="item.activity.name" v-model="item.use" :key="item.activity.id"/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="" text @click="showDlg=false">
            Abbrechen
          </v-btn>
          <v-btn color="primary" @click="onOk">
            Speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <drag-drop-list-dlg :list="counters" :open="showDragDlg" text-key="name" id-key="id" @ok="onDragOk"
                        @cancel="showDragDlg=false"/>
  </v-main>
</template>

<script>
import Counter from "@/components/Counter";

const {DateTime} = require("luxon");
import Duration from 'luxon/src/duration.js'
import Header1 from "@/components/Header1";
import CenterContainer from "@/components/CenterContainer";
import Kinds from "@/components/Kinds";
import Activity from "@/components/Activity";
import Datum from "@/components/Datum";
import ActivityLibrary from "@/components/ActivityLibrary";
import BEREICHE from "@/components/Bereiche";
import Vue from "vue";
import {ArrayX} from "@/reusable/array_extensions";
import DragDropListDlg from "@/components/DragDropListDlg";
import UserLib from "@/components/UserLib";

import {Ziele} from "@/components/Ziele";
import Pro from "@/components/Pro";

const CONTEXT = "@counters";

export default {
  name: "Counters",
  components: {Counter, CenterContainer, Header1, DragDropListDlg, Pro},
  data() {
    return {
      dateTime: undefined,
      count: 17,
      counters: [], // activities to be displayed as counter
      counterActivities: [], // activities that can be used for a counter
      allActivities: {},
      selected_activity: undefined,
      showDlg: false,
      countersToUse: [],
      showDragDlg: false,
      targets: undefined,
      activitySums: {},
    };
  },
  mounted() {
    if (!this.$app.is_logged_in) {
      this.$store.commit("set", {key: "intern", value: false});
      if (this.$route.path != "/")
        this.$router.replace("/");
      return;
    }
    this.$store.commit("set", {key: "intern", value: true});
    this.load();
  },
  methods: {
    async load() {
      this.datetime = DateTime.fromJSDate(new Date(Date.now())).setLocale("de");
      this.loading = true;
      // --> load activities (for checking validity and adding counters)
      var activities = await this.$backend.get_all_objects(Kinds.KIND_ACTIVITY);
      activities=activities.filter(x=>!x.deleted);
      //console.log({activities});
      this.counterActivities = [];
      (activities ?? []).forEach(a => {
        if (!a.name)
          return;
        this.allActivities[a.id] = a;
        if (!this.isEingabeToday(a))
          return;
        if (a.type != ActivityLibrary.TYPE_NUMERIC)
          return;
        if (a.unit == "Minuten" || a.unit == "Stunden" || a.unit == "Zeit")
          return;
        this.counterActivities.push({text: a.name, value: a});
      });
      // --> load counters
      var settings = await this.$backend.get_settings(CONTEXT, {onError: this.onLoadError});
      if (settings && settings.counters) {
        this.counters = [];
        settings.counters.forEach(aid => {
          var activity = this.allActivities[aid];
          if (!activity)
            return;
          this.counters.push(activity);
          if (this.counterActivities.filter(x=>x.value.id==activity.id).length==0)
            this.counterActivities.push({text: activity.name, value: activity});
        });
        // this.counters = this.counters.sort(function (a, b) {
        //   return a.name.localeCompare(b.name);
        // });
      }
      if (this.counters.length === 0)
        this.showConfig = 0; // this will show the config
      this.loading = false;
      this.targets=(await this.$backend.get_object(Kinds.KIND_ZIELE, Ziele.makeId( new Date(Date.now()).getFullYear()))||{});
      this.activitySums=(await this.$backend.get_object(Kinds.KIND_ACTIVITY_SUMS, Datum.getStartOfWeekIso(new Date(Date.now())))||{});
    },
    save() {
      this.loading = true;
      console.log("Saving counters: ", this.counters);
      var settings = {counters: []};
      this.counters.forEach(a => settings.counters.push(a.id));
      this.$backend.set_settings(CONTEXT, settings, {
        onSuccess: this.onSaveSuccess,
        onError: this.onSaveError,
        no_notify: true,
      });
      this.load();
    },
    onConfigure() {
      var xcounters = new ArrayX(this.counters);
      this.countersToUse = this.counterActivities.map(item => ({
        activity: item.value,
        use: xcounters.contains(item.value)
      }));
      this.showDlg = true;
    },
    onOk() {
      this.showDlg = false;
      var xcounters = new ArrayX(this.counters);
      this.countersToUse.forEach(x => {
        if (x.use && !xcounters.contains(x.activity))
          xcounters.add(x.activity);
        else if (!x.use && xcounters.contains(x.activity))
          xcounters.remove(x.activity);
      });
      this.save();
    },
    onDragOk(reorderedCounters) {
      this.showDragDlg = false;
      this.counters = reorderedCounters;
      this.save();
    },
    onSaved(activity) {
    },
    isEingabeToday(a) {
      var eingabe = false;
      if ((a.input || ActivityLibrary.INPUT_DAILY) == ActivityLibrary.INPUT_DAILY) eingabe = true;
      if (this.datetime.weekday == 1 && a.input == ActivityLibrary.INPUT_MO) return true;
      if (this.datetime.weekday == 2 && a.input == ActivityLibrary.INPUT_DI) return true;
      if (this.datetime.weekday == 3 && a.input == ActivityLibrary.INPUT_MI) return true;
      if (this.datetime.weekday == 4 && a.input == ActivityLibrary.INPUT_DO) return true;
      if (this.datetime.weekday == 5 && a.input == ActivityLibrary.INPUT_FR) return true;
      if (this.datetime.weekday == 6 && a.input == ActivityLibrary.INPUT_SA) return true;
      if (this.datetime.weekday == 7 && a.input == ActivityLibrary.INPUT_SO) return true;
      //console.log("Eingabe => " + a.name + " => " + a.input + " => " + (eingabe ? "ja" : "#### NEIN ###"));
      return eingabe;
    },
  },
  computed: {
    isFree() {
      return this.$app.isFree;
    },
    isSilver() {
      return this.$app.isSilver;
    },
    isGold() {
      return this.$app.isGold;
    },
    isMobile() {
      return this.$app.mobile;
    },
    canConfig() {
      return true;
      // if(this.$app.isPrivateUser)
      //   return true;
      // if(this.$app.isDirector)
      //   return true;
      // return false;
    },
  },
  watch: {
    // selected_activity(n, o){
    //   this.$app.save("stoppuhrActivityId", n?n.id:undefined);
    //   if (o && n!=o) {
    //     this.$app.save("startTimeIso", undefined);
    //     this.startTime=undefined;
    //     this.timeString="00:00:00";
    //   }
    //   this.updateOffsetDuration(n);
    // }
  }
}
</script>

<style scoped>

</style>